import './App.css';

export default function FeaturedApp() {
  return (
    <div className="legal-container">
      <p className="announcement-date">13 APRIL 2026</p>
      <h1 className="legal-title">Raven Becomes a Featured App on Canton Network</h1>
      <div className="legal-body">
        <p>Raven Market is a Featured App on the <a href="https://x.com/CantonNetwork" target="_blank" rel="noreferrer">@CantonNetwork</a>.</p>

        <p>This reflects our participation in a system where applications are measured by what they actually generate — transactions, fees, and sustained usage. On Canton, that is what determines how applications participate in network economics.</p>

        <h2>What the Designation Actually Means</h2>

        <p>Featured App status is not a marketing designation. It is tied to real, fee-generating activity on the network. Applications are evaluated based on measurable contribution. Participation in rewards follows directly from that contribution.</p>

        <p>There are no grants. No subjective allocations. The system is driven entirely by usage.</p>

        <h2>How Canton Thinks About Applications</h2>

        <p>Most networks separate infrastructure and applications economically. Builders drive activity. Value accrues elsewhere.</p>

        <p>Canton takes a different approach. A meaningful share of network rewards flows to applications, distributed based on their share of network activity. This creates a direct relationship between activity, fees, and economic participation.</p>

        <p>Applications are not external to the system. They are part of it.</p>

        <h2>Why Raven Belongs Here</h2>

        <p>Raven Market is a digital options protocol. Every contract lifecycle generates measurable, fee-backed activity on Canton. A trade entry mints collateral — 1 CC locked at the protocol level. AMM interactions move the pool on every buy, sell, and early exit. Settlement resolves every outcome onchain via Chainlink oracle.</p>

        <p>Each of these steps is a real transaction. Each generates real fees.</p>

        <p>Unlike incentive-driven usage or artificial volume, Raven's activity is structurally embedded in the product itself. Every position a trader opens, holds, or closes is a fee-generating event. The protocol doesn't manufacture throughput. It produces it naturally through usage. This aligns directly with how Canton measures and rewards contribution.</p>

        <h2>Privacy at the Application Layer</h2>

        <p>Derivatives require confidentiality. A trader's position size, direction, and entry price are sensitive. Exposing them publicly undermines the integrity of the market and the privacy of the participant.</p>

        <p>Canton's selective disclosure model allows Raven to operate with private financial workflows at the application layer — while remaining fully measurable at the network level through fees. Position details stay private. Economic contribution remains visible and verifiable.</p>

        <p>This is not a compromise. It is precisely the architecture financial applications require.</p>

        <h2>Where the Network Is Heading</h2>

        <p>Canton is moving toward a model where rewards are increasingly tied to real fee generation and sustained activity. As the network matures, durable financial flows matter more than superficial transaction volume. Applications generating consistent, fee-backed activity become structurally more relevant in this environment.</p>

        <p>Raven is built to generate exactly that. Digital options are not one-click interactions. They are committed positions with defined durations, continuous AMM pricing, and deterministic settlement. Every contract that opens on Raven runs its full lifecycle on Canton.</p>

        <h2>The Objective Stays the Same</h2>

        <p>Featured App status places Raven within the part of the system where activity and network economics directly intersect. Canton introduces a model where applications participate directly in the value they create. This shifts the focus from access to contribution.</p>

        <p>For Raven, the objective is unchanged — build a derivatives protocol that generates real, sustained, fee-backed activity on Canton. Options trading volume. Collateral throughput. AMM depth. Settlement frequency.</p>

        <p>Real flows. Real fees. Real participation. That's the only metric that matters here.</p>
      </div>
    </div>
  );
}
